import "babel-polyfill";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import { toast } from "react-toastify";

import { OidcProvider } from "redux-oidc";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import configureStore, { history, persistor } from "./store/configureStore";
import { userManagerFactory } from "./services/oidc/utils/userManager";

import { api, formDataApi, ajaxApiNoAuthorize, pdfApi } from "./api-services";

import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import MonitoringQueueEntryDetailsModal from "./features/monitoring-queue-entry/components/details-modal/MonitoringQueueEntryDetailsModal";
import { PersistGate } from "redux-persist/integration/react";

const rootElement = document.getElementById("root");

const apiUrl = process.env.REACT_APP_API_URL;
const amlJavaApi = process.env.REACT_APP_AML_JAVA_API;

const apis = {
  ajaxApi: api(apiUrl, amlJavaApi),
  formDataApi: formDataApi(apiUrl, amlJavaApi),
  ajaxApiNoAuthorize: ajaxApiNoAuthorize(apiUrl),
  pdfApi: pdfApi(apiUrl, amlJavaApi),
};

toast.configure({
  autoClose: 8000,
  draggable: false,
});

const store = configureStore(apis);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <OidcProvider store={store} userManager={userManagerFactory()}>
        <Suspense fallback={""}>
          <ConnectedRouter history={history}>
            <App />
            <MonitoringQueueEntryDetailsModal />
          </ConnectedRouter>
        </Suspense>
      </OidcProvider>
    </PersistGate>
  </Provider>,

  rootElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js